
export class Gpu {
    static adapter: GPUAdapter;
    static device: GPUDevice;

    static async initGpu(): Promise<void> {
        if (!navigator.gpu) {
            throw new Error("WebGPU not supported");
        }

        this.adapter = await navigator.gpu.requestAdapter();
        if (!this.adapter) {
            throw new Error("Failed to get GPU adapter");
        }

        this.device = await this.adapter.requestDevice({
            requiredLimits: {
                maxColorAttachmentBytesPerSample: 64,
                maxStorageBuffersPerShaderStage: 10
            },
            requiredFeatures: ['shader-f16', 'float32-filterable']
        });

        this.device.lost.then((info) => {
            console.error('WebGPU device lost:', info.message);
        });
    }

}